import React, { useEffect } from 'react';
import back from '../dist/webImages/back.svg';
import { Form, Formik } from 'formik';
import { Link, useNavigate } from 'react-router-dom';
import swal from 'sweetalert';
import { toast } from 'react-toastify';
import FormControl from '../components/form/FormControl';
import SubmitButton from '../components/SubmitButton';
import usePost2 from '../customHooks/usePost2';

const CreatePeopleVisit = () => {
  const navigate = useNavigate();
  const [res, apiMethod] = usePost2();

  const initialValues = {
    slug: '',
  };

  const handleSubmit = async (values) => {
    if (!values.slug?.trim()) {
      swal({
        title: 'Required fields are empty',
        text: 'Slug',
        icon: 'error',
        dangerMode: true,
      });
      return;
    }

    await apiMethod('people-visits', {
      slug: values.slug.trim(),
    });
  };

  useEffect(() => {
    if (res.error) {
      toast.error(res?.error?.response?.data?.message ?? 'Failed to create people visit');
    }
  }, [res.error]);

  useEffect(() => {
    if (res.data) {
      const { status, message } = res.data;

      if (status === 'false' || status === false) {
        toast.error(message);
        return;
      }

      toast.success(message ?? 'People visit created successfully');
      navigate('/people-visits');
    }
  }, [navigate, res.data]);

  return (
    <section className='PushNotificationCreate pr-10 max-lg:pr-6'>
      <Link to='/people-visits' className='back flex items-center mb-5 gap-2'>
        <img src={back} className='w-[2rem]' alt='' />
        <span className='text-[1.4rem] font-MluvkaBold'>Create People Visit</span>
      </Link>

      <div className='relative flex items-start gap-3'>
        <div className='bg-white rounded-xl w-full mx-auto relative'>
          <Formik initialValues={initialValues} onSubmit={handleSubmit}>
            <Form name='peopleVisitsCreateForm'>
              <div className='bg-[#EFF4FD] p-6 rounded-3xl mb-3 max-lg:p-3'>
                <FormControl
                  name='slug'
                  label='Slug'
                  placeholder='Enter slug'
                  className='outline-none w-full h-[3rem] px-5 rounded-xl'
                  control='input2'
                />
              </div>

              <SubmitButton
                props={{
                  class: 'btn bg-secondary text-white px-12 ml-auto uppercase mb-3 py-3 rounded-full w-100 block mt-5 submit hover:bg-primary transition-all duration-300',
                  text: 'Submit',
                }}
                buttonLoading={res.isLoading}
              />
            </Form>
          </Formik>
        </div>
      </div>
    </section>
  );
};

export default CreatePeopleVisit;
